import React from 'react';
import { WWSetCard } from './ww-set-card';
import { WWSetProfile } from './ww-set-profile';
import { WWSetMin } from './ww-set-min';

interface IProps {
  name: string;
  mode: string;
}

export const WWSet: React.FC<IProps> = ({ name, mode }) => {
  return (
    <>
      {mode === 'card' && <WWSetCard set={name} />}
      {mode === 'profile' && <WWSetProfile set={name} />}
      {mode === 'min' && <WWSetMin set={name} />}
    </>
  );
};
